// extracted by css-extract-rspack-plugin
export default {"dot":"_5e72a3f9","activeDot":"_e894c035","medium":"_416b0b7b","small":"_f28a61f9","dark":"_fd2be9da"};